import { render, staticRenderFns } from "./EmbarquesHistoricos.vue?vue&type=template&id=367917bc&"
import script from "./EmbarquesHistoricos.vue?vue&type=script&lang=js&"
export * from "./EmbarquesHistoricos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports